(function() {
$(document).on("change", "#new_organisation_driver_entry #organisation_driver_entry_customer_id", (function(_this) {
  return function(e) {
    return _this.alpha_oms_utils.submit_form("new_organisation_driver_entry");
  };
})(this));

$(document).on("change", "#new_organisation_driver_entry #organisation_driver_entry_payment_intention", (function(_this) {
  return function(e) {
    return _this.alpha_oms_utils.submit_form("new_organisation_driver_entry");
  };
})(this));

$(document).on("keyup", "#new_organisation_driver_entry #organisation_driver_entry_amount_to_pay_on_card", (function(_this) {
  return function(e) {
    var $form_group_elem, _card_amount, _entry_price, _invoice_amount, _max_card_amount, _min_card_amount;
    _card_amount = e.target.value;
    _entry_price = parseFloat($(e.target).data("entry-price"));
    _min_card_amount = parseFloat($(e.target).data("min-card-amount"));
    _max_card_amount = parseFloat($(e.target).data("max-card-amount"));
    $form_group_elem = $(e.target).closest(".form-group");
    if ((_card_amount >= _min_card_amount) && (_card_amount <= _max_card_amount)) {
      _invoice_amount = _entry_price - _card_amount;
      $("#amount_to_pay_on_invoice").text(_invoice_amount.toFixed(2));
      $form_group_elem.removeClass("has-error");
      return $("#organisations_driver_entry_form_terms_and_submit").fadeIn(200);
    } else {
      $form_group_elem.addClass("has-error");
      return $("#organisations_driver_entry_form_terms_and_submit").fadeOut(200);
    }
  };
})(this));

}).call(window);
